import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import { CustomTab } from '../../../components'
import { Box } from '@mui/material';

const EmailReportTab = () => {
  const navigate = useNavigate();

  return (
    <Box mt={-2}>
      <CustomTab
        panels={[
          {
            name: "Reportes",
            route: '/reportes/correos',
            onChange: () => navigate('/reportes/correos'),
            content: <Outlet />
          },
          {
            name: "Historial",
            route: '/reportes/correos/historial_global',
            onChange: () => navigate('historial_global'),
            content: <Outlet />
          },
        ]}
      />
    </Box>
  )
}

export default EmailReportTab